import { add, isAfter } from 'date-fns';
import _ from 'platform/utilities/data';
import {
  FORM_STATUS_BDD,
  SAVED_SEPARATION_DATE,
} from '../../shared/constants/entryConstants';
import { getToday, parseDate } from '../../shared/utils/dates';

export const isBDD = formData => {
  const isBddDataFlag = Boolean(formData?.['view:isBddData']);
  const servicePeriods = formData?.serviceInformation?.servicePeriods || [];

  // separation date entered in the wizard
  const separationDate = window.sessionStorage.getItem(SAVED_SEPARATION_DATE);

  // isActiveDuty is true when the user selects that option in the wizard & then
  // enters a separation date - based on the session storage value; we then
  // set this flag in the formData.
  // If the user doesn't choose the active duty wizard option, but enters a
  // future date in their service history, this may be associated with reserves
  // and therefor should not open the BDD flow
  const isActiveDuty = isBddDataFlag || separationDate;

  if (
    !isActiveDuty ||
    // User hasn't started the form or the wizard
    (servicePeriods.length === 0 && !separationDate)
  ) {
    return false;
  }

  const mostRecentDate = separationDate
    ? parseDate(separationDate)
    : servicePeriods
        .filter(({ dateRange }) => dateRange?.to)
        .map(({ dateRange }) => parseDate(dateRange?.to))
        .sort((dateA, dateB) => dateB - dateA)[0];

  if (!mostRecentDate) {
    window.sessionStorage.setItem(FORM_STATUS_BDD, 'false');
    return false;
  }

  const today = getToday();
  const today89 = add(today, { days: 89 });
  const today180 = add(today, { days: 180 });

  const result =
    isActiveDuty &&
    isAfter(mostRecentDate, today89) &&
    !isAfter(mostRecentDate, today180);

  // this flag helps maintain the correct form title within a session
  window.sessionStorage.setItem(FORM_STATUS_BDD, result ? 'true' : 'false');
  return Boolean(result);
};

export const getBddShaUploads = formData =>
  _.get('separationHealthAssessmentUploads', formData, []);

export const hasShaDocumentUploaded = formData =>
  getBddShaUploads(formData).length > 0;
